import { render, staticRenderFns } from "./WhatsappDetailIncomingInfo.vue?vue&type=template&id=3be3f4f2&"
import script from "./WhatsappDetailIncomingInfo.vue?vue&type=script&lang=ts&"
export * from "./WhatsappDetailIncomingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports